import useFileUploadWithDialog from './useFileUploadWithDialog';
import { transformFileToImageObject } from '../../media/photo';

const useImageUploadWithDialog = ({
  multiple = true,
  extensions = 'jpg, jpeg, png, bmp',
  validateFile,
  beforeOpen,
  onCancel,
  onClear,
  onCompleted,
  transform = transformFileToImageObject,
  model,
  fileNameSuffix,
}) => {
  const fileUploadDialog = useFileUploadWithDialog({
    multiple,
    extensions,
    validateFile,
    transform,
    beforeOpen,
    onCancel,
    onClear,
    onCompleted,
    model,
    fileNameSuffix,
  });

  return {
    ...fileUploadDialog,
  };
};

export default useImageUploadWithDialog;
